import Code from "app/models/code"
import { Action, Types } from "./codes.actions"

export type CodesState = {
  code: Code | undefined
  data: Code[] | undefined
  errors: {}
  loading: boolean
}

const initialState: CodesState = {
  code: undefined,
  data: undefined,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): CodesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.DELETE:
      return {
        ...state,
        loading: true,
      }

    case Types.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.DELETE_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        code: action.payload.data,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH:
      return {
        ...state,
        loading: true,
      }

    case Types.PATCH_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
